/* Dazzuro — pastilles des coloris NON canape (tables, buffets, miroirs, luminaires).

   Les images viennent de assets/pastilles-couleurs.json (nom du coloris normalise -> image),
   un fichier a part : AUCUN lien avec la bibliotheque de textures des tissus.
   Le script marque chaque pastille traitee (data-daz-texture-applique) pour que
   dazzuro-texture-swatches.js, qui lit la bibliotheque, ne la repasse pas. */
(function () {
  'use strict';
  var URL_JSON = window.DAZ_PASTILLES_URL;
  if (!URL_JSON) return;
  var table = null;
  var frame = null;

  function normaliser(v) {
    return String(v || '')
      .normalize('NFD').replace(/\p{M}/gu, '')
      .replace(/[\u200B-\u200F\uFEFF]/g, '')
      .toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function appliquer() {
    if (!table) return;
    var liste = document.querySelectorAll('[data-daz-texture-swatch]');
    for (var i = 0; i < liste.length; i += 1) {
      var el = liste[i];
      var label = el.getAttribute('data-daz-texture-swatch');
      var url = table[normaliser(label)];
      if (!url || el.getAttribute('data-daz-pastille') === url) continue;
      el.style.setProperty('--swatch-background-image', 'url("' + url + '")');
      el.classList.add('with-image');
      el.setAttribute('data-daz-pastille', url);
      el.setAttribute('data-daz-texture-applique', label);
    }
  }

  function programmer() {
    if (frame) return;
    frame = requestAnimationFrame(function () { frame = null; appliquer(); });
  }

  fetch(URL_JSON)
    .then(function (r) { return r.json(); })
    .then(function (j) {
      table = j.couleurs || {};
      appliquer();
      new MutationObserver(programmer).observe(document.body, { childList: true, subtree: true });
    })
    .catch(function () {});
})();
